(function () {
    window.NewsGraph = window.NewsGraph || {};

    class NewsGraphControls {
        constructor(container, pivot, camera) {
            this.container = container;
            this.pivot = pivot;
            this.camera = camera;

            this.panX = 0;
            this.panY = 0;
            this.autoRotate = true;
            this.autoRotateController = null;

            if (window.NewsGraph && window.NewsGraph.NewsGraphAutoRotateController) {
                this.autoRotateController = new window.NewsGraph.NewsGraphAutoRotateController({
                    enabled: this.autoRotate,
                    speed: 0.0015,
                    onChange: (active) => {
                        this.autoRotate = active;
                        if (this.onAutoRotateChange) this.onAutoRotateChange(active);
                    }
                });
            }

            const THREE = window.THREE;
            const overlay = document.createElement('div');
            overlay.style.cssText = 'position:absolute;inset:0;z-index:5;cursor:grab;touch-action:pan-x pan-y;';
            this.container.appendChild(overlay);
            this.overlay = overlay;

            const DRAG_THRESHOLD = 5;
            const drag = {
                active: false,
                button: -1,
                x: 0,
                y: 0,
                startX: 0,
                startY: 0,
                isDragging: false
            };
            this.drag = drag;
            this._touchDistance = 0;
            this._startCameraZ = 0;

            this._onContextMenu = e => e.preventDefault();
            this._onMouseDown = e => {
                e.preventDefault();
                drag.active = true;
                drag.button = e.button;
                drag.x = e.clientX;
                drag.y = e.clientY;
                drag.startX = e.clientX;
                drag.startY = e.clientY;
                drag.isDragging = false;
                this.overlay.style.cursor = 'grabbing';
                if (e.button === 0) this.disableAutoRotate();
            };

            this._onMouseUp = (e) => {
                this.overlay.style.cursor = 'grab';
                if (drag.active && !drag.isDragging && drag.button === 0 && this.onClick) {
                    this.onClick(e.clientX, e.clientY);
                }
                drag.active = false;
                drag.isDragging = false;
            };
            this._onMouseMove = e => {
                if (!drag.active) return;

                if (drag.button === 0) {
                    if (!drag.isDragging) {
                        const dist = Math.hypot(e.clientX - drag.startX, e.clientY - drag.startY);
                        if (dist > DRAG_THRESHOLD) {
                            drag.isDragging = true;
                        } else {
                            return;
                        }
                    }

                    let action = 'rotate';
                    if (window.StockStorm3DInteraction && typeof window.StockStorm3DInteraction.getMainAction === 'function') {
                        action = window.StockStorm3DInteraction.getMainAction();
                    }

                    if (action === 'rotate') {
                        const dx = (e.clientX - drag.x) * 0.01;
                        const dy = (e.clientY - drag.y) * 0.01;

                        let quatX = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), dy);
                        let quatY = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), dx);

                        const newQuat = quatY.multiply(quatX).multiply(this.pivot.quaternion);
                        this.pivot.quaternion.copy(newQuat).normalize();
                    } else if (action === 'move') {
                        const dx = e.clientX - drag.x;
                        const dy = e.clientY - drag.y;
                        const speed = this.camera.position.z / 400;
                        this.panX += dx * speed;
                        this.panY -= dy * speed;
                    }
                } else if (drag.button === 2) {
                    const dx = e.clientX - drag.x;
                    const dy = e.clientY - drag.y;
                    const speed = this.camera.position.z / 400;
                    this.panX += dx * speed;
                    this.panY -= dy * speed;
                }

                drag.x = e.clientX;
                drag.y = e.clientY;
            };
            this._onWheel = e => {
                e.preventDefault();
                this.camera.position.z = Math.max(0.5, Math.min(500,
                    this.camera.position.z + e.deltaY * 0.04
                ));
            };

            this._onTouchStart = e => {
                if (e.touches.length === 2) {
                    drag.active = false;
                    this._touchDistance = this._getTouchDistance(e);
                    this._startCameraZ = this.camera.position.z;
                    this.disableAutoRotate();
                    if (e.cancelable) e.preventDefault();
                    return;
                }

                if (e.touches.length !== 1) return;

                const interactionEnabled = !window.StockStorm3DInteraction ||
                    typeof window.StockStorm3DInteraction.isEnabled !== 'function' ||
                    window.StockStorm3DInteraction.isEnabled();

                if (!interactionEnabled) return;

                const touch = e.touches[0];
                drag.active = true;
                drag.button = 0;
                drag.x = touch.clientX;
                drag.y = touch.clientY;
                drag.startX = touch.clientX;
                drag.startY = touch.clientY;
                drag.isDragging = false;
                this.disableAutoRotate();
            };

            this._onTouchMove = e => {
                if (e.touches.length === 2 && this._touchDistance > 0) {
                    if (e.cancelable) e.preventDefault();
                    const nextDistance = this._getTouchDistance(e);
                    if (nextDistance > 0) {
                        const scale = this._touchDistance / nextDistance;
                        this.camera.position.z = this._clampCameraZ(this._startCameraZ * scale);
                    }
                    return;
                }

                if (!drag.active || e.touches.length !== 1) return;
                const touch = e.touches[0];
                const clientX = touch.clientX;
                const clientY = touch.clientY;

                let action = 'rotate';
                if (window.StockStorm3DInteraction && typeof window.StockStorm3DInteraction.getMainAction === 'function') {
                    action = window.StockStorm3DInteraction.getMainAction();
                }

                const interactionEnabled = !window.StockStorm3DInteraction ||
                    typeof window.StockStorm3DInteraction.isEnabled !== 'function' ||
                    window.StockStorm3DInteraction.isEnabled();

                if (!interactionEnabled) {
                    drag.active = false;
                    return;
                }

                if (!drag.isDragging) {
                    const dist = Math.hypot(clientX - drag.startX, clientY - drag.startY);
                    if (dist > DRAG_THRESHOLD) {
                        drag.isDragging = true;
                    } else {
                        return;
                    }
                }

                e.preventDefault();

                if (action === 'rotate') {
                    const dx = (clientX - drag.x) * 0.01;
                    const dy = (clientY - drag.y) * 0.01;

                    let quatX = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), dy);
                    let quatY = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), dx);

                    const newQuat = quatY.multiply(quatX).multiply(this.pivot.quaternion);
                    this.pivot.quaternion.copy(newQuat).normalize();
                } else if (action === 'move') {
                    const dx = clientX - drag.x;
                    const dy = clientY - drag.y;
                    const speed = this.camera.position.z / 400;
                    this.panX += dx * speed;
                    this.panY -= dy * speed;
                }

                drag.x = clientX;
                drag.y = clientY;
            };

            this._onTouchEnd = e => {
                if (drag.active && !drag.isDragging && this.onClick) {
                    this.onClick(drag.startX, drag.startY);
                }
                drag.active = false;
                drag.isDragging = false;
                this._touchDistance = 0;
            };

            overlay.addEventListener('contextmenu', this._onContextMenu);
            overlay.addEventListener('mousedown', this._onMouseDown);
            overlay.addEventListener('wheel', this._onWheel, { passive: false });
            overlay.addEventListener('touchstart', this._onTouchStart, { passive: false });
            overlay.addEventListener('touchmove', this._onTouchMove, { passive: false });
            overlay.addEventListener('touchend', this._onTouchEnd, { passive: true });
            overlay.addEventListener('touchcancel', this._onTouchEnd, { passive: true });
            window.addEventListener('mouseup',   this._onMouseUp);
            window.addEventListener('mousemove', this._onMouseMove);
        }

        update() {
            if (this.autoRotateController) {
                this.autoRotateController.tick(this.pivot);
            } else if (this.autoRotate) {
                const THREE = window.THREE;
                const autoQuat = new THREE.Quaternion().setFromAxisAngle(
                    new THREE.Vector3(0, 1, 0), 0.0015
                );
                this.pivot.quaternion.premultiply(autoQuat);
            }
            this.pivot.position.set(this.panX, this.panY, 0);
            const interactionEnabled = !window.StockStorm3DInteraction ||
                typeof window.StockStorm3DInteraction.isEnabled !== 'function' ||
                window.StockStorm3DInteraction.isEnabled();
            this.overlay.style.touchAction = interactionEnabled ? 'none' : 'pan-x pan-y';
        }

        enableAutoRotate() {
            if (this.autoRotateController) {
                this.autoRotateController.setEnabled(true);
            } else {
                this.autoRotate = true;
                if (this.onAutoRotateChange) this.onAutoRotateChange(true);
            }
        }

        disableAutoRotate() {
            if (this.autoRotateController) {
                this.autoRotateController.setEnabled(false);
            } else {
                this.autoRotate = false;
                if (this.onAutoRotateChange) this.onAutoRotateChange(false);
            }
        }

        destroy() {
            window.removeEventListener('mouseup',   this._onMouseUp);
            window.removeEventListener('mousemove', this._onMouseMove);
            this.overlay?.removeEventListener('touchstart', this._onTouchStart);
            this.overlay?.removeEventListener('touchmove', this._onTouchMove);
            this.overlay?.removeEventListener('touchend', this._onTouchEnd);
            this.overlay?.removeEventListener('touchcancel', this._onTouchEnd);
            this.overlay?.remove();
        }

        _getTouchDistance(event) {
            if (!event.touches || event.touches.length < 2) return 0;
            const a = event.touches[0];
            const b = event.touches[1];
            return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        }

        _clampCameraZ(value) {
            return Math.max(0.5, Math.min(500, value));
        }
    }

    window.NewsGraph.NewsGraphControls = NewsGraphControls;
})();
